import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import TestPage from "./pages/TestPage"
import Home from "./pages/Home"
import About from "./pages/About"
import WhyUs from "./pages/WhyUs"
import Faq from "./pages/Faq"
import Crypto from "./pages/Crypto"
import Forex from "./pages/Forex"
import Stocks from "./pages/Stocks"
import Stock from "./pages/Stock"
import Mystock from "./pages/Mystock"
import Stock1 from "./pages/Stock1"
import Stocklist from "./pages/Stocklist"
import Legal from "./pages/Legal"
import Policy from "./pages/Policy"
import Terms from "./pages/Terms"
import LoginPage from "./pages/LoginPage"
import Register from "./pages/Register"
import Forget from "./pages/Forget"
import Reset from "./pages/Reset"
import Dashboard from "./pages/Dashboard"
import Dashboard1 from "./pages/Dashboard1"
import Deposit from "./pages/Deposit"
import Withdraw from "./pages/Withdraw"
import Assets from "./pages/Assets"
import Markets from "./pages/Markets"
import Mining from "./pages/Mining"
import Trade from "./pages/Trade"
import Subscribe from "./pages/Subscribe"
import Copyexpert from "./pages/Copyexpert"
import Signal from "./pages/Signal"
import Stake from "./pages/Stake"
import Components from "./pages/Components"
import { UserProvider } from "./utils/UserContext";
import "./App.css"

function App() {
  return (
    <Router>
      <UserProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/testpage" element={<TestPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/whyus" element={<WhyUs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/crypto" element={<Crypto />} />
          <Route path="/forex" element={<Forex />} />
          <Route path="/stocks" element={<Stocks />} />
          <Route path="/stock" element={<Stock />} />
          <Route path="/mystock" element={<Mystock />} />
          <Route path="/stock1" element={<Stock1 />} />
          <Route path="/stocklist" element={<Stocklist />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/dashboard1" element={<Dashboard1 />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<Forget />} />
          <Route path="/reset-password" element={<Reset />} />
          <Route path="/assets" element={<Assets />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/mining" element={<Mining />} />
          <Route path="/trade" element={<Trade />} />
          <Route path="/copyexpert" element={<Copyexpert />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/signal" element={<Signal />} />
          <Route path="/stake" element={<Stake />} />
          <Route path="/components" element={<Components />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </UserProvider>
    </Router>
  )
}

export default App